<td
    class="member-cell"
    [class.nonreporting]="
        member.isCurrentlyReporting !== true &&
        activeView == ACTIVE_TAB_VIEW.TEAM
    "
    (click)="forceOADetails($event, true)"
    [colSpan]="member.active === true ? activecolumns : 1"
>
    <div
        class="member-name-container row text-left d-flex justify-content-start align-items-center"
        style="position: relative"
    >
        <cmps-icon
            class="cmps-cdk-fill-grey-300 cmps-cdk-text-center member-chevron"
            [class.col-2]="rowExpanded !== true"
            [class.active]="member.active === true"
            [svgIcon]="
                member.active !== true ? 'chevron-right' : 'chevron-down'
            "
        ></cmps-icon>
        <span
            class="member-name"
            [ngClass]="{
                active: member.active === true,
                'col-10': rowExpanded != true
            }"
        >
            <span
                class="photo-name-sec"
                [ngClass]="{ 'photo-name-width': rowExpanded != true }"
            >
                <cmps-icon
                    class="user-icon"
                    svgIcon="account-circle"
                ></cmps-icon>
                <span
                    [cmpsTooltipTrigger]="membertooltip"
                    placement="right-center"
                    [cmpsTooltipTriggerCustomTemplate]="true"
                >
                    {{ member.firstName | titlecase }}
                    {{ member.lastName | titlecase }}
                </span>
            </span>

            <span *ngIf="member.active == true">
                <span
                    *ngIf="member.supergroupName"
                    class="member-supergroup-name pl-2"
                    >- {{ i18n._67_SUPERGROUP | translate }}:
                    {{ member.supergroupName }}</span
                >
                <span class="member-name-close">
                    <cmps-icon svgIcon="close"></cmps-icon>
                </span>
            </span>
        </span>
    </div>
</td>

<ng-container *ngIf="member.active != true">
    <ng-container *ngFor="let col of columns | async; let index">
        <ng-container *ngIf="col.templateName !== null">
            <ng-container
                *ngTemplateOutlet="
                    {
                        oascore: oascore,
                        coachedopps: coachedopps,
                        uncoachedopps: uncoachedopps,
                        nonopps: nonopps,
                        nonkpi: nonkpi,
                        missedopps: missedopps
                    }[col.templateName];
                    context: { col: col }
                "
            ></ng-container>
        </ng-container>
    </ng-container>
</ng-container>

<!-- column templates-->
<ng-template
    #oascore
    let-col="col"
>
    <td
        class="overall-coaching-score"
        [ngClass]="col.class"
        *ngIf="col.active == true && member.active === false"
    >
        <button
            type="button"
            [style.color]="member.oaThreshold"
            class="non-button"
            #oascore="cmpsTooltipTrigger"
            [cmpsTooltipTrigger]="scoretooltip"
            trigger="none"
            [cmpsTooltipTriggerCustomTemplate]="true"
            (click)="oascore.toggle()"
        >
            <ng-container *ngIf="member.oaScore != null; else noScore">
                {{ member.oaScore }}
                <span class="score-percentage">%</span>
            </ng-container>
            <ng-template #noScore>-</ng-template>
        </button>
    </td>
</ng-template>

<ng-template
    #coachedopps
    let-col="col"
>
    <td
        class="member-oa"
        [ngStyle]="col.cellstyles"
        *ngIf="col.active == true && member.active === false"
    >
        <metric-list
            *ngIf="col.compactView === false && member.coached.length"
            [metrics]="member.coached"
            [dimensionIndex]="col.index"
            (clicked)="setActiveMember($event)"
        >
        </metric-list>
        <button
            *ngIf="col.compactView === true && member.coached.length"
            class="nonkpi-button"
            #c="cmpsTooltipTrigger"
            [cmpsTooltipTrigger]="collapsedCoachedTooltip"
            placement="left-center"
            trigger="none"
            [cmpsTooltipTriggerTemplateContext]="{
                opps: member.coached,
                title: col.header
            }"
            [cmpsTooltipTriggerCustomTemplate]="true"
            (click)="c.toggle()"
        >
            <span>{{ member.coached.length }}</span>
        </button>
    </td>
</ng-template>

<ng-template
    #uncoachedopps
    let-col="col"
>
    <td
        class="member-oa uncoached"
        [ngStyle]="col.cellstyles"
        *ngIf="col.active == true && member.active === false"
    >
        <metric-list
            *ngIf="col.compactView === false && member.uncoached.length"
            [dimensionIndex]="col.index"
            [metrics]="member.uncoached"
            (clicked)="setActiveMember($event)"
        >
        </metric-list>
        <button
            *ngIf="col.compactView === true && member.uncoached.length"
            class="nonkpi-button"
            #u="cmpsTooltipTrigger"
            [cmpsTooltipTrigger]="collapsedCoachedTooltip"
            placement="left-center"
            trigger="none"
            [cmpsTooltipTriggerTemplateContext]="{
                opps: member.uncoached,
                title: col.header
            }"
            [cmpsTooltipTriggerCustomTemplate]="true"
            (click)="u.toggle()"
        >
            <span>{{ member.uncoached.length }}</span>
        </button>
    </td>
</ng-template>

<ng-template
    #missedopps
    let-col="col"
>
    <td
        class="member-missed"
        [ngStyle]="col.cellstyles"
        *ngIf="col.active == true && member.active === false"
    >
        <metric-list
            *ngIf="col.compactView === false && member.missed.length"
            [dimensionIndex]="col.index"
            [metrics]="member.missed"
            (clicked)="setActiveMember($event)"
        >
        </metric-list>
        <button
            *ngIf="col.compactView === true && member.missed?.length"
            class="nonkpi-button"
            #g="cmpsTooltipTrigger"
            [cmpsTooltipTrigger]="missedOppsTooltip"
            placement="left-center"
            trigger="none"
            [cmpsTooltipTriggerTemplateContext]="{ missedopps: member.missed }"
            [cmpsTooltipTriggerCustomTemplate]="true"
            (click)="g.toggle()"
        >
            <span>{{ member.missed?.length }}</span>
        </button>
    </td>
</ng-template>

<ng-template
    #nonopps
    let-col="col"
>
    <td
        class="member-nonoa"
        [ngStyle]="col.cellstyles"
        *ngIf="col.active == true && member.active === false"
    >
        <metric-list
            *ngIf="col.compactView === false && member.nonoa.length"
            [dimensionIndex]="col.index"
            [metrics]="member.nonoa"
            (clicked)="setActiveMember($event)"
        >
        </metric-list>
        <button
            *ngIf="col.compactView === true && member.nonoa.length"
            class="nonkpi-button"
            #h="cmpsTooltipTrigger"
            [cmpsTooltipTrigger]="collapsedCoachedTooltip"
            placement="left-center"
            trigger="none"
            [cmpsTooltipTriggerTemplateContext]="{
                opps: member.nonoa,
                title: col.header
            }"
            [cmpsTooltipTriggerCustomTemplate]="true"
            (click)="h.toggle()"
        >
            <span>{{ member.nonoa.length }}</span>
        </button>
    </td>
</ng-template>

<ng-template
    #nonkpi
    let-col="col"
>
    <td
        class="member-non-kpi"
        [ngStyle]="col.cellstyles"
        *ngIf="col.active == true && member.active === false"
    >
        <button
            *ngIf="member.nonKPICoaching"
            class="nonkpi-button"
            (click)="
                activetab = 'tab-performance';
                openedWithNonKPIButton.emit(true);
                forceOADetails($event)
            "
            [cmpsTooltipTrigger]="nonkpitooltip"
            placement="left-center"
            [cmpsTooltipTriggerTemplateContext]="{
                nonkpicommitments: member.nonKpiCommitments
            }"
            [cmpsTooltipTriggerCustomTemplate]="true"
        >
            <cmps-icon svgIcon="account-multiple"></cmps-icon>
            <span>{{ member.nonKPICoaching }}</span>
        </button>
    </td>
</ng-template>

<!-- hover templates -->
<ng-template #scoretooltip>
    <div class="oa-widget-tooltip custom-tooltip oatooltip">
        <div class="metric-mini-view">
            <table>
                <tr class="metric-view-divider">
                    <th>{{ i18n._7370_EXPECTED_COACHING | translate }}</th>
                    <td>{{ member.expectedOpportunities }}</td>
                </tr>
                <tr class="metric-view-divider">
                    <th>{{ i18n._7371_COACHED_OPPORTUNITIES | translate }}</th>
                    <td>{{ member.coachedOpportunities }}</td>
                </tr>
                <tr class="metric-view-divider">
                    <th>{{ i18n._7372_TOTAL_OPPORTUNITIES | translate }}</th>
                    <td>{{ member.totalOpportunities }}</td>
                </tr>
            </table>
        </div>
    </div>
</ng-template>

<ng-template
    let-ctx="ctx"
    #nonkpitooltip
>
    <div
        class="oa-widget-tooltip non-kpi-tooltip-left custom-tooltip nonkpitooltip"
    >
        <div class="metric-mini-view">
            <table>
                <tr
                    *ngFor="
                        let nonkpi of ctx?.nonkpicommitments;
                        let index = index;
                        trackBy: identifyNonKPIObject(index, nonkpi)
                    "
                    class="metric-view-divider"
                >
                    <td>
                        <div class="nonkpi-tooltip-behaviour">
                            {{ nonkpi.behaviour }}
                        </div>
                        <div class="nonkpi-tooltip-subbehaviour">
                            {{ nonkpi.subbehaviour }}
                        </div>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</ng-template>

<ng-template
    #membertooltip
    let-memberdata="memberdata"
>
    <div class="oa-widget-tooltip custom-tooltip offset-right memberdata">
        <div class="metric-mini-view">
            <table>
                <tr class="metric-view-divider">
                    <td>{{ i18n._7373_SUPERGROUP_NAME | translate }}</td>
                    <td>{{ member.supergroupName }}</td>
                </tr>
                <tr class="metric-view-divider">
                    <td>{{ i18n._7374_DAYS_IN_SUPERGROUP | translate }}</td>
                    <td>{{ member.supergroupAge }}</td>
                </tr>
                <tr class="metric-view-divider">
                    <td>{{ i18n._48_MANAGER | translate }}</td>
                    <td>{{ member.managerName }}</td>
                </tr>
                <tr class="metric-view-divider">
                    <td>{{ i18n._59_ROLE | translate }}</td>
                    <td>{{ member.roleName }}</td>
                </tr>
            </table>
        </div>
    </div>
</ng-template>

<ng-template
    let-ctx="ctx"
    #missedOppsTooltip
>
    <div
        class="oa-widget-tooltip collapse-tooltip custom-tooltip interactive-tooltip missedoppstooltip"
    >
        <div class="metric-mini-view">
            <div class="missed-opps-title">
                {{ i18n._7508_MISSED_OPPORTUNITIES | translate }}
            </div>
            <ul class="missed-opps-list">
                <ng-container
                    *ngFor="let opp of ctx?.missedopps; let i = index"
                >
                    <li class="metric-links">
                        <metric-button
                            metricBtn
                            [opportunity]="opp"
                            (clicked)="setActiveMember($event)"
                            (click)="$event.stopPropagation()"
                        >
                        </metric-button>
                    </li>
                </ng-container>
            </ul>
        </div>
    </div>
</ng-template>

<!-- WITH COLLAPSED COLUMN BUTTONS -->
<ng-template
    let-ctx="ctx"
    #collapsedCoachedTooltip
>
    <div
        class="oa-widget-tooltip collapse-tooltip custom-tooltip interactive-tooltip missedoppstooltip"
    >
        <div class="metric-mini-view">
            <div class="missed-opps-title">{{ ctx?.title }}</div>
            <ul class="missed-opps-list">
                <ng-container *ngFor="let opp of ctx?.opps; let i = index">
                    <li class="metric-links">
                        <metric-button
                            metricBtn
                            [opportunity]="opp"
                            (clicked)="setActiveMember($event)"
                            (click)="$event.stopPropagation()"
                        >
                        </metric-button>
                    </li>
                </ng-container>
            </ul>
        </div>
    </div>
</ng-template>
